import { useState } from "react"
import { fetchApi } from "@inmagik/react-crud"
import { Formik, getIn } from "formik"
import { API_URL } from "../constants"
import { Link } from "react-router-dom"
import yup from "../utils/validations"
import { Button, CharField, H2 } from "@inmagik/magik-ui"

const schema = yup.object().shape({
  email: yup.string().email().required().label("Email"),
})

const initialValues = {
  email: "",
}

export function PasswordDimenticata() {
  const [confirm, setConfirm] = useState(false)
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        backgroundImage: "url(/sfondo.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100%",
        height: "100vh",
      }}
    >
      <Formik
        validationSchema={schema}
        initialValues={initialValues}
        enableReinitialize
        onSubmit={async (values) => {
          await fetchApi(API_URL + "/userbase/recover-password/", {
            method: "POST",
            body: JSON.stringify(values),
            responseType: "raw",
            headers: {
              "Content-Type": "application/json",
              
            },
          }).then((e) => {
            setConfirm(true)
          })
        }}
      >
        {({ handleSubmit, touched, errors, values, setFieldValue, submitCount }) => (
          <form onSubmit={handleSubmit}>
            <div
              style={{
                borderRadius: "1rem",
                border: "1px solid #fafafa",
                background: "linear-gradient(145deg, rgba(255, 255, 255, 0.4) 2.91%, rgba(255, 255, 255, 0.8) 97.55%)",
                boxShadow: "0px 4px 24px -1px rgba(0, 0, 0, 0.15)",
                backdropFilter: "blur(10px)",
                display: "flex",
                width: "464px",
                padding: "32px",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
                height: "max-content",
              }}
            >
              <div className="d-flex flex-column align-items-center">
                <H2 className="text-center">Password dimenticata</H2>
              </div>
              <div>Inserisci la tua email e ti invieremo le istruzioni per recuperare la password.</div>
              <div className="w-100">
                <div className="form-group">
                  <CharField
                    label="Email"
                    className="mb-2"
                    placeholder="Inserisci la tua email"
                    required
                    value={values.email}
                    onChange={(value) => {
                      setFieldValue("email", value)
                    }}
                    isValid={submitCount > 0 ? !getIn(errors, "email") : undefined}
                    errorMessage={getIn(errors, "email")}
                  />
                </div>
                <div>
                  {confirm && (
                    <div className="alert alert-success mt-2 py-1">
                      Ti è stata inviata una email con le istruzioni per recuperare la password. Vai al{" "}
                      <Link to="/login">login</Link>
                    </div>
                  )}
                </div>
                <Button
                  type="submit"
                  className="w-100 mt-4 text-white d-flex align-items-center justify-content-center"
                  size="md"
                  variant="primary"
                  title="Recupera password"
                />
              </div>
            </div>
          </form>
        )}
      </Formik>
    </div>
  )
}
